export default "__VITE_ASSET__6VmfU6QZ__"